<template>
  <div id="page-attendance">
    <el-form
      class="search-form"
      :inline="true"
      :model="searchForm"
      ref="searchForm"
      label-width="8em"
    >
      <el-row>
        <el-form-item prop="businessLine" label="业务线" required>
          <filter-business-line :value.sync="searchForm.businessLine" required ops />
        </el-form-item>
        <el-form-item prop="partnerId" label="合作商" required>
          <filter-businessline-partner
            :value.sync="searchForm.partnerId"
            :businessLine="searchForm.businessLine"
            required
          />
        </el-form-item>
        <el-form-item prop="regionId" label="Region" required>
          <filter-businessline-region
            :value.sync="searchForm.regionId"
            :businessLine="searchForm.businessLine"
            required
            multiple
          />
        </el-form-item>
        <el-form-item prop="workType" label="工种" v-if="+searchForm.businessLine === 2">
          <filter-job-type :value.sync="searchForm.workType" />
        </el-form-item>
        <el-form-item label="姓名/手机">
          <el-input
            :maxlength="32"
            placeholder="非必填"
            clearable
            v-model.trim="searchForm.userNameOrPhone"
          />
        </el-form-item>
        <el-form-item label="时间段" required>
          <filter-date-range :value.sync="dateRange" :init-range="7" required />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="fetchData(true)" :loading="isLoading">查询</el-button>
          <el-button @click="exportDataList" :loading="isDownloading">导出</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="u-main-body">
      <el-table :data="workerList" v-loading="isLoading">
        <el-table-column
          v-for="(item, index) in tableColumn"
          :key="`${item.label}${index}${item.prop}`"
          :prop="item.prop"
          :label="item.label"
          min-width="120"
        >
          <template slot-scope="scope">
            <template v-if="item.prop.indexOf('day') > -1">
              <div class="date-list">
                <span class="date-detail" :class="{ 'text-red': scope.row[item.prop] === '异常' }">
                  {{ scope.row[item.prop] || '—' }}
                </span>
                <el-button
                  type="text"
                  class="detail-btn"
                  @click="getScheduleData(item, scope.row)"
                  :disabled="!scope.row[item.prop]"
                  >查看详情</el-button
                >
              </div>
            </template>
            <template v-else-if="item.prop === 'userNameAndPhone'">
              <common-decode
                :type="DECODE_TYPE.PHONE"
                :value="scope.row.userNameAndPhone"
                :token="scope.row.empId"
              />
            </template>
            <template v-else>
              {{ scope.row[item.prop] || '—' }}
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div class="paging-wrapper" v-if="totalPages > 1">
        <el-pagination
          background
          @current-change="handlePageNoChange"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          layout="prev, pager, next, slot, jumper"
          :total="totalAmount"
        >
          <span class="page-indicator"
            ><em>{{ pageNo }}</em
            >/{{ totalPages }}</span
          >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      width="80%"
      :title="dialogtitle"
      :visible.sync="dialogDetailVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="top-detail">
        <div class="item-detail" v-for="(item, index) in scheduleList" :key="index">
          <el-row>
            <el-col :span="6">
              <span>班次：{{ formatArrangementTime(item.arrangementTime) }}</span>
            </el-col>
            <el-col :span="6">
              <span>时长：{{ item.lengthOfTime | formatWorkTime }}</span>
            </el-col>
          </el-row>

          <el-row class="ui-mt-10">
            <el-col :span="6">
              <span>考勤状态：{{ item.statusName || '' }}</span>
            </el-col>
          </el-row>

          <el-table
            stripe
            show-overflow-tooltip
            :data="item.clockInRecordDTOs"
            v-loading="isLoading"
            class="detail-table ui-mt-10"
          >
            <el-table-column label="打卡时间" prop="clockInTime" />
            <el-table-column label="打卡位置" prop="localName" />
            <el-table-column label="考勤围栏" prop="clockInFencingName" />
            <el-table-column label="打卡位置校验" prop="locationStatus">
              <template slot-scope="scope">
                <span :class="+scope.row.locationStatus !== 0 ? 'text-red' : ''">{{
                  scope.row.locationStatusDesc
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="人脸识别" prop="faceStatus">
              <template slot-scope="scope">
                <span :class="+scope.row.faceStatus !== 0 ? 'text-red' : ''">{{
                  scope.row.faceStatusDesc
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="图片" prop="imgUrl">
              <template slot-scope="scope" v-if="scope.row.imgUrl">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="[scope.row.imgUrl]"
                />
              </template>
              <template v-else><span></span></template>
            </el-table-column>
            <el-table-column label="备注" prop="locationAbnormalReason" />
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dateFormat, secondFomart } from '@/utils'
import pagination from '@/mixins/pagination'
import getValidDateNum from '@/mixins/getValidDateNum'
import CommonDecode from './components/PhoneDecode.vue'
import { DECODE_TYPE } from '@/enums/constant'

export default {
  mixins: [pagination, getValidDateNum],
  components: {
    CommonDecode,
  },
  data() {
    // 详情围栏状态
    this.fenceStatusMap = {
      0: '正常',
      1: '在其他围栏内',
      2: '不在任何围栏内',
    }
    this.statusMap = {
      0: '正常',
      1: '异常',
      default: '—',
    }
    return {
      DECODE_TYPE,
      workerList: [],
      isLoading: false,
      isDownloading: false,
      isLoadingDetail: false,
      dialogDetailVisible: false,
      ceilDetail: {},
      dateRange: [],
      tableColumn: [],
      scheduleList: [],
      cacheParams: {},
      pageSize: 20,
      searchForm: {
        businessLine: 2,
        workType: '',
        userNameOrPhone: '',
        partnerId: '',
        regionId: [],
        startTime: '',
        endTime: '',
        clockStatus: '',
        jobPositionId: '',
        staffType: '',
        userId: '',
      },
    }
  },

  created() {
    this.initPagination('fetchData', false)
  },

  methods: {
    formatArrangementTime(arrangementTime) {
      if (!arrangementTime || arrangementTime.length === 0) return '-'

      return arrangementTime.map(item => item.arrangementTimeStr).join()
    },
    // 获取当天排班信息
    getScheduleData(item, rowObj = {}) {
      this.dialogDetailVisible = true
      this.detailRowObj = JSON.parse(JSON.stringify(rowObj))
      const currentName =
        this.detailRowObj.userNameAndPhone && this.detailRowObj.userNameAndPhone.split('/')[0]
      this.dialogtitle = `${currentName || ''} ${item.label || ''}`
      const params = {
        clockInDate: new Date(item.label).getTime(),
        clockUserType: 1,
        userId: rowObj.userId,
      }
      this.isLoading = true
      this.fetch
        .post('queryClockInDetailByDate', params)
        .then(res => {
          this.isLoading = false
          const data = res.data || {}
          this.scheduleList = data.shiftClockInStreamDTOS || []
        })
        .catch(() => {
          this.isLoading = false
          this.scheduleList = []
        })
    },
    // 列表
    fetchData(init = false) {
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        startTime: dateFormat(this.dateRange[0]),
        endTime: dateFormat(this.dateRange[1]),
        page: this.pageNo,
        pageSize: this.pageSize,
      }

      if (!params.partnerId) {
        return this.$message.error('请选择合作商')
      }

      if (!params.regionId || !params.regionId.length) {
        return this.$message.error('请选择region')
      }
      this.cacheParams = params

      this.isLoading = true
      this.fetch
        .post('queryClockInRecordList', params)
        .then(res => {
          // 减少动态渲染table造成的跳动
          setTimeout(() => {
            this.isLoading = false
          }, 200)
          const resData = res.data || {}
          this.totalAmount = resData.totalCount || 0
          this.tableColumn = resData.columnList || []

          this.workerList = (resData.contentList || []).map(item => {
            const tmpDateList = item.dateList || []
            tmpDateList.forEach(subItem => {
              item[subItem.prop] = subItem.label
            })
            return item
          })
        })
        .catch(() => {
          this.isLoading = false
          this.workerList = []
          this.tableColumn = []
        })
    },

    // 导出
    exportDataList() {
      delete this.cacheParams.page
      delete this.cacheParams.pageSize
      this.isDownloading = true

      this.fetch
        .post('exportClockinRecordList', this.cacheParams)
        .then(res => {
          this.$message.success(res && res.message)
          this.isDownloading = false
        })
        .catch(() => {
          this.isDownloading = false
        })
    },

    // 单元格点击
    onCellClick(cellObj = {}, row = {}) {
      const params = {
        clockDate: cellObj.label,
        sysUserId: row.userId,
      }
      if (!params.clockDate) return
      this.dialogDetailVisible = true
      this.isLoadingDetail = true
      this.ceilDetail = {}
      this.fetch
        .get('queryClockInDetailByDate', { params })
        .then(res => {
          this.isLoadingDetail = false
          this.ceilDetail = res.clockInStreamDTO || {}
        })
        .catch(() => {
          this.isLoadingDetail = false
        })
    },
  },

  filters: {
    formatWorkTime(val) {
      return secondFomart(val) || '-'
    },
  },
}
</script>

<style lang="scss">
#page-attendance {
  .date-list {
    .detail-btn {
      display: none;
    }
    .text-red {
      color: red;
    }
    &:hover {
      .detail-btn {
        display: inline-block;
      }
      .date-detail {
        display: none;
      }
    }
  }
  .top-detail {
    .text-tip {
      color: #ff4612;
    }

    .item-detail {
      margin-bottom: 20px;
    }
  }
  .detail-table {
    .text-red {
      color: #ff4612;
    }
  }
  .ui-mt-10 {
    margin-top: 10px;
  }
}
</style>
